/* eslint-disable no-console */

export const browserLogger = {
  log(...args: any[]) {
    console.log(...args)
  },
  info(...args: any[]) {
    console.info(...args)
  },
  debug(...args: any[]) {
    console.debug(...args)
  },
  warn(...args: any[]) {
    console.warn(...args)
  },
  error(...args: any[]) {
    console.error(...args)
  },
}
